/* 🤖 this file was generated by svg-to-ts */
export const matIconNoCrash: {
  name: 'no-crash';
  data: string;
} = {
  name: 'no-crash',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18.92 9.01C18.72 8.42 18.16 8 17.5 8h-11c-.66 0-1.21.42-1.42 1.01L3 15v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 10h10.29l1.04 3H5.81l1.04-3zM19 20H5v-5h14v5zM6 17.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S8.33 19 7.5 19 6 18.33 6 17.5zm9 0c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5zM12 6.36 9.17 3.54l1.41-1.41L12 3.54 15.54 0l1.41 1.41L12 6.36z"/></svg>`
};
